import { Avatar } from '@george-labs.com/design-system';
import type { ICON } from '@george-labs.com/george-assets/icons';

import { isFeatureEnabled } from '@luna/gatekeeper';
import type { MyProfile } from '@shared/profile';

import { WatchdogType } from './WatchdogsTypes';

export const WATCHDOGS_BASENAME = 'settings/watchdogs/edit/*';

const WATCHDOG_TYPE_ICON_MAP = {
    [WatchdogType.Balance]: Avatar.ICON.CHART_VERTICAL,
    [WatchdogType.Cards]: Avatar.ICON.CARD_CREDITCARD,
    [WatchdogType.IncomingTrx]: Avatar.ICON.PFM_OTHER_INCOMING,
    [WatchdogType.OutgoingTrx]: Avatar.ICON.PFM_OTHER_OUTGOING,
    [WatchdogType.Misc]: Avatar.ICON.NOTIFICATION,
    [WatchdogType.Reg924]: Avatar.ICON.RELOAD,
    [WatchdogType.OrderStatus]: Avatar.ICON.SIGN,
    [WatchdogType.QuotationAlert]: Avatar.ICON.PORTFOLIO,
    [WatchdogType.InstantPayment]: Avatar.ICON.FLASH,
    [WatchdogType.RequestToPay]: Avatar.ICON.HAND_COINS,
    [WatchdogType.Crm]: Avatar.ICON.NEWSLETTER,
    [WatchdogType.RegAuth]: Avatar.ICON.USER_EDIT,
    [WatchdogType.RegEChannel]: Avatar.ICON.DEVICES,
    [WatchdogType.RegCards]: Avatar.ICON.CARD_SETTINGS,
};

export function getWatchdogIcon(watchdogType: WatchdogType = WatchdogType.Misc): ICON {
    return WATCHDOG_TYPE_ICON_MAP[watchdogType];
}

export function areWatchdogsEnabled(
    customerSegment: MyProfile['customerSegment'] | undefined,
): boolean {
    if (!isFeatureEnabled((features) => features.watchdogs)) {
        return false;
    }

    if (
        isFeatureEnabled((features) => features.watchdogs.filterForLegalEntities) &&
        customerSegment === 'LEGAL_ENTITY'
    ) {
        return false;
    }

    return true;
}
